export default __webpack_public_path__ + "static/media/testimonial2.6df658e2.svg";